module.exports = __webpack_public_path__ + "img/IMG_5183_lang_1.eddd9030.jpg";